import React, { useContext } from 'react';
import { PageContext } from '../providers/page-provider';

export const StepTimeline = () => {
  const { currentStep, stepsSubmitted } = useContext(PageContext);

  const steps = [
    {label: "1", value: "STEP_ONE", name: "AR Costs"},
    {label: "2", value: "STEP_TWO", name: "Cash Flow"},
    {label: "3", value: "STEP_THREE", name: "Scalability"},
    {label: "4", value: "STEP_FOUR", name: "Resilience"},
    {label: "5", value: "STEP_FIVE", name: "Business Info"}
  ];

  const getStepClassName = (value) => {
    if (value === currentStep) {
      return "step-current";
    }
    if (stepsSubmitted.includes(value)) {
      return "step-submited"
    }
    return "step-unactive"
  }

  const getLineClassName = (value) => {
    if (stepsSubmitted.includes(value)) {
      return "step-line-active"
    }
    return "step-line-unactive"
  }


  return (
    <nav className="timeline">
      {
        steps.map(({label, value, name}, index) => {
          return (
            <React.Fragment key={label}>
              <div className={getStepClassName(value)}>{label}</div>
              <div className="step-name">{name}</div>
              {
                index !== steps.length -1 && <div className={getLineClassName(value)}></div>
              }
            </React.Fragment>
          )
        })
      }
    </nav>
  )
}